import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CancelIcon } from '../../../assets/images/cancel_24px.svg';
import { ReactComponent as SearchIcon } from '../../../assets/images/searchIcon.svg';
import { t } from '../../../providers';

const useStyles = makeStyles((theme) => ({
    searchInput: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        '& input': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
                paddingLeft: '7px',
                marginLeft: '0px',
            },
        },
    },
    searchLabel: {
        fontSize: '0.75rem',
        fontWeight: '600',
        color: theme.palette.text.mainGreen,
        marginBottom: '0px',
        letterSpacing: '-0.2px',
        lineHeight: '15.96px',
        marginTop: '24px',
    },
    textInput: {
        height: '32px',
        width: '100%',
        background: '#ffffff',
        border: '1px solid #B1B1B1',
        borderRadius: '3px',
        '& input': {
            '&::placeholder': {
                paddingLeft: '2px',
                opacity: '1',
                color: theme.palette.text.chipgrey,
                fontSize: '0.875rem',
                fontWeight: '400',
                letterSpacing: '-0.2px',
                lineHeight: '19.88px',
            },
        },
        '@media (max-width:600px)': {
            width: '12.5rem',
        },
        '& .MuiInputAdornment-positionEnd': {
            marginLeft: '0px',
        },
    },
    searchButton: {
        color: theme.palette.text.mainGreen + '!important', //
        border: '1px solid' + theme.palette.text.mainGreen,
        borderRadius: '2px',
        height: '32px',
        minWidth: '4.5rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        lineHeight: '12px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '&:hover': {
            backgroundColor: theme.palette.text.primaryLight,
        },
    },
    disabledSearch: {
        cursor: 'not-allowed',
    },
    cancelBtn: {
        padding: '5px 10px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    searchIcon: {
        pointerEvents: 'none',
        padding: '10px',
    },
    searchSection: {
        width: '928px',
        '@media (max-width:1506px)': {
            paddingBottom: '15px',
        },
        '@media (max-width:1357px)': {
            width: '98%',
        },
        '@media (max-width:1100px)': {
            width: '99%',
        },
    },
}));

const SearchFilter = ({ onSearch, searchQuery, onClear, searchFilterLabelText = 'search.tm.services' }) => {
    const classes = useStyles();

    const [search, setSearch] = useState('');

    useEffect(() => {
        setSearch(searchQuery);
    }, [searchQuery]);

    const handleSearchChange = (event) => {
        if (searchQuery && search.length >= 1 && event.target.value.length === 0) {
            onClear();
        }
        setSearch(event.target.value);
    };

    const doSearch = () => onSearch(search);

    const onClearSearch = () => {
        setSearch('');
        onClear();
        const searchInput = document.getElementById('search');
        searchInput.focus();
    };

    return (
        <div className={classes.searchSection}>
            <InputLabel htmlFor="search" className={classes.searchLabel}>
                {t(searchFilterLabelText)}
            </InputLabel>
            <div className={classes.searchInput}>
                <Input
                    id="search"
                    className={classes.textInput}
                    placeholder={t('search.filter.placeholder')}
                    name="search"
                    fullWidth
                    endAdornment={
                        <InputAdornment position="end">
                            {!search ? (
                                <SearchIcon aria-hidden="true" focusable="false" className={classes.searchIcon} />
                            ) : (
                                <IconButton
                                    aria-label={t('clear.search')}
                                    disableFocusRipple
                                    id={'cancelButton'}
                                    onClick={onClearSearch}
                                    className={classes.cancelBtn}>
                                    <CancelIcon aria-hidden="true" focusable="false" />
                                </IconButton>
                            )}
                        </InputAdornment>
                    }
                    onChange={handleSearchChange}
                    value={search}
                />
                <Button
                    id={'searchButton'}
                    onClick={doSearch}
                    className={[classes.searchButton, search.length < 3 ? classes.disabledSearch : ''].join(' ')}
                    disableRipple
                    disableFocusRipple>
                    {t('search')}
                </Button>
            </div>
        </div>
    );
};

export default SearchFilter;
